export default function scrollToTop(topPos = 0) {
  if (window)
    window.scrollTo({
      top: topPos,
      behavior: 'smooth',
    });
}
